import React, { useState } from 'react'
import CustomAutoComplete from '../../../../components/CustomAutoComplete';
import Dropdown from '../../../../components/Dropdown';
import MonthRangePicker from '../../../../components/MonthRangePicker';
import TextInput from '../../../../components/TextInput';
import { useDispatch, useSelector } from 'react-redux';
import { searchJobScoutRecommend } from 'reducers/companyTalent';

const ManagementSection = ({ formAdvanceData, setFormAdvanceData, handleChange, handleSearchTalent }) => {
  const dispatch = useDispatch();
  const { recruitmentRankOptions, statusOptions, dateOptions, scoutHistoryOptions, jobScoutRecommendOptions } = useSelector((state: any) => state.companyTalent);
  const [scoutJobTitle, setScoutJobTitle] = useState("");

  const handleChangeJobScoutTitle = (value: any) => {
    setScoutJobTitle(value);
    dispatch(searchJobScoutRecommend({ search: value }));
  };

  return (
    <>
      <p className='text-sm font-bold alu-text-base-2 mb-6'>管理項目</p>
      <div className='flex flex-col gap-8'>
        <div className='grid grid-cols-6 gap-10'>
          <div className="col-span-1">
            <label className="block text-sm mb-2 alu-text-base-1">採用ランク</label>
            {/* recruitment_rank */}
            <Dropdown
              clearable={true}
              inputWidth="full"
              options={recruitmentRankOptions}
              placeholder=""
              value={formAdvanceData.recruitment_rank}
              onChange={(value: any) => {
                setFormAdvanceData((prev) => ({ ...prev, recruitment_rank: value }))
              }}
            />
          </div>
          <div className="col-span-3">
            <label className="block text-sm mb-2 alu-text-base-1">選考状況</label>
            <div className='flex items-center gap-2'>
              {/* status */}
              <div className='w-[calc(100%-160px)]'>
                <Dropdown
                  clearable={true}
                  inputWidth="full"
                  options={statusOptions}
                  placeholder=""
                  value={formAdvanceData.status}
                  onChange={(value: any) => {
                    setFormAdvanceData((prev) => ({ ...prev, status: value }))
                  }}
                  optionStyles='min-w-[104px] px-2 py-[0.125rem] rounded-2xl bg-[#E0E0E0] text-center'
                  multiple={true}
                />
              </div>
              <div className='w-[152px] shrink-0'>
                <Dropdown
                  clearable={true}
                  inputWidth="full"
                  options={dateOptions}
                  placeholder=""
                  value={formAdvanceData.status_date_rank}
                  onChange={(value: any) => {
                    setFormAdvanceData((prev) => ({ ...prev, status_date_rank: value }))
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className='grid grid-cols-3 gap-10'>
          <div className="col-span-1">
            <label className="block text-sm mb-2 alu-text-base-1">スカウト送信履歴</label>
            {/* scout_history */}
            <Dropdown
              clearable={true}
              inputWidth="full"
              options={scoutHistoryOptions}
              placeholder=""
              value={formAdvanceData.scout_history}
              onChange={(value: any) => {
                setFormAdvanceData((prev) => ({ ...prev, scout_history: value }))
              }}
            />
          </div>
          <div className="col-span-1">
            <label className="block text-sm mb-2 alu-text-base-1">スカウトした求人</label>
            {/* scout_job_id */}
            <CustomAutoComplete
              placeholder={""}
              options={jobScoutRecommendOptions}
              noOptionsMessage={'検索結果が見つかりませんでした'}
              value={formAdvanceData.scout_job_obj}
              inputValue={scoutJobTitle}
              onInputChange={handleChangeJobScoutTitle}
              onChange={(value: any) => {
                setFormAdvanceData((prev) => ({ ...prev, scout_job_id: value?.value, scout_job_obj: value }))
              }}
              isCustomOption={false}
              isClearable={true}
              menuPlacement='top'
            />
          </div>
          <div className="col-span-1">
            <label className="block text-sm mb-2 alu-text-base-1">エージェント情報</label>
            {/* register_code */}
            <TextInput
              size="md"
              name="agent_info"
              value={formAdvanceData.agent_info}
              onChange={handleChange}
              onKeyDown={(e: any) => e.key === "Enter" && handleSearchTalent(e)}
              placeholder=""
              clearIcon={true}
              onClearQuery={() => {
                setFormAdvanceData((prev: any) => ({
                  ...prev,
                  agent_info: '',
                }));
              }}
            />
          </div>
        </div>
        <div className='flex gap-10'>
          <div className="flex-1">
            <label className="block text-sm mb-2 alu-text-base-1">オーナー期限 開始年月</label>
            {/* scout_history */}
            <div className='flex items-center gap-2'>
              <div className='flex-1'>
                <MonthRangePicker
                  anchor="top"
                  placeholderStart=""
                  placeholderEnd=""
                  type={3}
                  startMonth={formAdvanceData.ownership_period_start_date_start}
                  endMonth={formAdvanceData?.ownership_period_start_date_end ? formAdvanceData?.ownership_period_start_date_end : ''}
                  onChange={(start: any, end: any) => {
                    setFormAdvanceData((prev) => ({ ...prev, ownership_period_start_date_start: start, ownership_period_start_date_end: end }))
                  }}
                />
              </div>
            </div>
          </div>
          <div className="flex-1">
            <label className="block text-sm mb-2 alu-text-base-1">オーナー期限 終了年月</label>
            {/* scout_job_id */}
            <div className='flex items-center gap-2'>
              <div className='flex-1'>
                <MonthRangePicker
                  anchor="top"
                  placeholderStart=""
                  placeholderEnd=""
                  type={3}
                  startMonthDisabledTime={formAdvanceData.ownership_period_start_date_start}
                  startMonth={formAdvanceData.ownership_period_end_date_start}
                  endMonth={formAdvanceData?.ownership_period_end_date_end ? formAdvanceData?.ownership_period_end_date_end : ''}
                  onChange={(start: any, end: any) => {
                    setFormAdvanceData((prev) => ({ ...prev, ownership_period_end_date_start: start, ownership_period_end_date_end: end }))
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ManagementSection